import {
    ChangeDetectionStrategy,
    Component,
    type ElementRef,
    input,
    model,
    output,
    signal,
    afterNextRender,
    inject,
    Injector,
    viewChild,
} from '@angular/core';
import { form, FormField, maxLength, disabled } from '@angular/forms/signals';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgIcon } from '@ng-icons/core';
import {
    QpxButton,
    QpxIcon,
    QpxFormFieldDirectives,
    QpxFormFieldLabel,
} from '@quipex/shared/ui';
@Component({
    selector: 'qpx-quippy-pack-destination',
    imports: [
        FormField,
        MatButtonModule,
        NgIcon,
        QpxButton,
        QpxIcon,
        MatFormFieldModule,
        MatInputModule,
        QpxFormFieldDirectives,
        QpxFormFieldLabel,
    ],
    templateUrl: './pack-destination.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'grid min-w-0 grid-cols-1 gap-4' },
})
export class QuippyPackDestination {
    public readonly actionId = input.required<string>();
    public readonly busy = input(false);
    protected readonly descriptionExpanded = signal(false);
    private readonly injector = inject(Injector);
    private readonly descriptionInput =
        viewChild<ElementRef<HTMLTextAreaElement>>('descriptionInput');
    protected addDescription(): void {
        this.descriptionExpanded.set(true);
        afterNextRender(() => this.descriptionInput()?.nativeElement.focus(), {
            injector: this.injector,
        });
    }
    public readonly name = model('');
    public readonly description = model('');
    protected readonly nameField = form(this.name, (path) => {
        maxLength(path, 100);
        disabled(path, () => this.busy());
    });
    protected readonly descriptionField = form(this.description, (path) => {
        maxLength(path, 512);
        disabled(path, () => this.busy());
    });
    public readonly changed = output<void>();
    private readonly nameInput =
        viewChild<ElementRef<HTMLInputElement>>('nameInput');
    public focusName(): void {
        this.nameInput()?.nativeElement.focus();
    }
}
